import Cookies from 'js-cookie';

$(function () {
  const footerNewsletterCookie = Cookies.get(('NEWSLETTER_FOOTER'));
  const newsletterContainer = document.getElementsByClassName('newsletter__content')[0];
  const newsletterFormId = newsletterContainer.dataset.footerNl;
  const newsletterForm = document.getElementById("footer-nl-form").parentNode;
  const newsletterSuccessMessage = document.getElementById('footer-nl-success');

  if (footerNewsletterCookie === 'sent-away') {
    newsletterSuccessMessage.classList.add('visible');
    newsletterForm.classList.add('submitted');
  }

  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.formId == newsletterFormId) {
      if (e.detail.type == 'submit') {
        Cookies.set('NEWSLETTER_FOOTER', 'sent-away', { expires: 7 });
      }
      if (e.detail.type == 'embedOpen') {
        setTimeout(function(){
          const checkPrivacy = newsletterForm.querySelector('label.kl-private-reset-css-Xuajs1 .needsclick.kl-private-reset-css-Xuajs1');
          if (checkPrivacy) {
            checkPrivacy.style.fontSize = '10px';
            checkPrivacy.style.marginRight = 0;
            if (document.querySelector('body').classList.contains('template-page-archive')) {
              checkPrivacy.style.color = '#fff';
            }
          }
        }, 500);
      }
    }
  });
});
